import store from "../../store";
import { DATAS } from "@/datas";
import API_ENTRIES from "@/datas/membership/entries.js";

/**
 * /router/index.js
 * store 정보 세팅
 */
export default class SetStoreInfo {
  /**
   *
   * @param {*} router
   * @param {*} type
   */
  constructor(router, path) {
    this.router = router;
    this.appCode = DATAS.ASA_APP_CODE;
    this.setStoreCommon();
    switch (path) {
      case "membership":
        this.setStoreCafe24();
        break;
      default:
        break;
    }
  }

  /**
   * 공통 설정
   */
  setStoreCommon() {
    if (!store.state.appCode) {
      store.commit("SET_APP_CODE", this.appCode);
    }
  }

  /**
   * CAFE24 store 설정
   */
  setStoreCafe24() {
    if (!store.state.entries || !Array.isArray(store.state.entries)) {
      store.commit("SET_ENTRIES", API_ENTRIES);
    }

    this.router.beforeEach(async (to, from, next) => {
      try {
        if (!store.state.mallId) {
          let mall_id = to.query.mall_id;
          let mall_name = sessionStorage.getItem("mall_name");

          if (mall_id && Array.isArray(mall_id)) {
            mall_id = mall_id[0];
          }
          if (!mall_id) {
            mall_id = to.params.mall_id;
          }
          if (!mall_id) {
            throw new Error("requireAuth");
          }

          if (!mall_name && to.query.mall_name) {
            mall_name = to.query.mall_name;
            sessionStorage.setItem("mall_name", mall_name);
          }

          store.commit("SET_MALL_ID", mall_id);
          store.commit("SET_MALL_NAME", mall_name);
        }

        if (!store.state.accessToken) {
          let access_token = to.query.access_token;
          if (!access_token) {
            access_token = sessionStorage.getItem(
              `${store.state.mallId}_accessToken`
            );
            if (!access_token) {
              throw new Error("requireAuth");
            }
          }
          await store.dispatch("SET_ACCESS_TOKEN", {
            access_token: access_token,
          });
        }

        await store.dispatch("SET_VERSION");

        if (!store.state.mode) {
          throw new Error("requirePayment");
        }

        if (
          to.matched.some(
            (route) =>
              route.meta.requireModes === undefined ||
              (Array.isArray(route.meta.requireModes) &&
                route.meta.requireModes.includes(store.state.mode))
          )
        ) {
          next();
        } else {
          // 무한호출됨..
          // throw new Error("requirePayment");
        }
      } catch (error) {
        switch (error) {
          case "requireAuth":
            window.location.href = `https://${store.state.mallId}.cafe24.com/disp/admin/shop1/myapps/list`;
            break;
          case "requirePayment":
            alert("결제가 필요합니다.");
            // next({ path: `/authservice/${store.state.mallId}/payment` });
            break;
          default:
            next();
            break;
        }
      }
    });
  }
}
